import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Tab,
  Nav,
  Form,
  Modal,
  Accordion,
} from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { firestore as db } from "../config/Config";
import { useLocation } from "react-router-dom";
import { Collapse } from "bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchKitchenList } from "../redux/kitchenReducer";
import { useNavigate } from "react-router-dom";
import { auth } from "../config/Config";
import { createRooms } from "../redux/addRoomReducer";
import Sidebar from "./SidebarNav";


export default function ViewDesign({ clientDataFor }) {
  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;
  const bread = data.from
  console.log("data", data);
  console.log("data", data);

  useEffect(() => {
    dispatch(fetchKitchenList());
  }, []);

  const { userData, userLoader, userError } = useSelector((state) => state.viewusers);

  // Material things

  const [kitchenBaseGrandTotal, setKitchenBaseGrandTotal] = useState(0);

  const [materialType, setMaterialType] = useState("");
  const [materialLabel, setMaterialLabel] = useState(0);
  const [materialValue, setMaterialValue] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [modalUrl, setModalUrl] = useState("");
  const [materialWidth, setMaterialWidth] = useState(0);
  const [materialHeight, setMaterialHeight] = useState(0);
  // const [materialDepth, setMaterialDepth] = useState(2);
  const [materialQuantity, setMaterialQuantity] = useState(0);
  const [materialPrice, setMaterialPrice] = useState(0);
  const handleFistItem = (name) => {
    setModalTitle(name.label);
    setModalUrl(name.url);
  };




  const handleLogOut = () => {
    auth.signOut();
    // navigation('/login');
  }

  // for room type view dynamically

  const [roomTypeModal, setRoomTypeModal] = useState("");



  return (
    <Container fluid>
      <Row>
        <Col sm={1} >
          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>

          <Row className="px-5 py-2 ">
              <hr/>
            <Row className="d-flex justify-content-end col-sm-5 w-auto">
              <Breadcrumb>
                {data.from ? <Breadcrumb.Item

                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    height: 30,
                    width: 'auto',
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }} onClick={() =>
                    navigation("/assigned")
                  } >Assigne Rooms</Breadcrumb.Item> : <Breadcrumb.Item


                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      backgroundColor: "#ea6e2b",
                      borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                      height: 30,
                      width: 'auto',
                      paddingRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer", // Pointer on hover
                      marginLeft: "10px",

                      // Hover effect
                      ":hover": {
                        backgroundColor: "#FFA500", // Change background color on hover
                        transform: "scale(1.1)", // Slightly increase the size on hover
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                      }
                    }}
                    onClick={() => {
                      if (data.status === "completed") {
                        navigation("/completed");
                      } else {
                        navigation("/projects");
                      }
                    }}

                  >{ data.status==="completed" ? 'completed' : 'Projects'}</Breadcrumb.Item>}
                {data.from ? <Breadcrumb.Item
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    height: 30,
                    width: 'auto',
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }}
                  onClick={() =>
                    navigation("/projects/view-rooms", { state: data })
                  }
                >
                  { data.state=="completed" ? 'completed' : 'Projects'}
                </Breadcrumb.Item>
                  : <Breadcrumb.Item
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#333",
                      textTransform: "uppercase",
                      letterSpacing: "-0.5px",
                      backgroundColor: "#ea6e2b",
                      borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                      height: 30,
                      width: 'auto',
                      paddingRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer", // Pointer on hover
                      marginLeft: "10px",

                      // Hover effect
                      ":hover": {
                        backgroundColor: "#FFA500", // Change background color on hover
                        transform: "scale(1.1)", // Slightly increase the size on hover
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                      }
                    }}
                    onClick={() =>{
                    

                    if(data.status === "completed") {
                      navigation("/completed/completed-rooms", { state :data})
                    }
                  else{

                    navigation("/projects/view-rooms", { state: data })
                  }}
                  }
                  >
                    {data.pname}
                  </Breadcrumb.Item>}
                <Breadcrumb.Item
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    height: 30,
                    width: 'auto',
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }} active>View Design</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <hr/>
            {/* Room name and type modal */}
            <Row className="p-2" style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>

              <Row>

                <Col
                  sm={12}
                >
                  <Container>
                    <Row>
                      <Col style={{ minHeight: 380, maxHeight: 480 }}>
                        <h4>Room Details</h4>
                        <Row className=" border-bottom border-dark">
                          <Col><h6>Name </h6></Col>
                          <Col><h6>Material</h6></Col>
                          <Col><h6>Width</h6></Col>
                          <Col><h6>Height/length</h6></Col>
                          <Col><h6>Area/RFT</h6></Col>
                          <Col><h6>Base Price</h6></Col>
                          <Col><h6>Quantity</h6></Col>
                          <Col><h6>Price</h6></Col>
                          <Col><h6>Remark</h6></Col>
                        </Row>
                        {data?.viewData?.title && Array.isArray(data.viewData.title) ? data.viewData.title.map((item, index) => {
                          const price = Number(item.price) || 0;
                          const val = Number(item.value) || 0;
                          const isShape = item.name === "Shape Of Kitchen";
                          const hasContent = price > 0 || val > 0 || isShape || Boolean(item.label) || Boolean(item.remark);

                          if (hasContent && (price > 0 || val > 0 || isShape)) {
                            const w = parseFloat(item.width);
                            const h = parseFloat(item.height);
                            const computedArea = item.area
                              ? item.area
                              : (!isNaN(w) && !isNaN(h) && w > 0 && h > 0)
                                ? (w * h).toFixed(2).replace(/\.00$/, '')
                                : (item.rft || '');

                            return (
                              <Row key={index} className="border-bottom border-dark-subtle p-2">
                                <Col><h6>{item.name} {item.label2 ? `  (${item.label2})` : null}</h6></Col>
                                <Col><h6>{item.label || '-'}</h6></Col>
                                <Col><h6>{item.width || '-'}</h6></Col>
                                <Col><h6>{item.height || '-'}</h6></Col>
                                <Col><h6>{computedArea || '-'}</h6></Col>
                                <Col><h6>{item.value || 0}</h6></Col>
                                <Col><h6>{item.qnty ? item.qnty : '-'}</h6></Col>
                                <Col><h6>{item.price || 0}</h6></Col>
                                <Col><h6>{item.remark || '-'}</h6></Col>
                              </Row>
                            );
                          }
                          return null;
                        }) : null}

                        {data?.viewData?.title2 && Array.isArray(data.viewData.title2) && data.viewData.title2.length > 0 ? (
                          <>
                            <Row className="mt-4 mb-2 border-bottom border-secondary">
                              <Col><h5>Extra Items</h5></Col>
                            </Row>
                            {data.viewData.title2.map((item, index) => (
                              <Row key={`extra-${index}`} className="border-bottom border-dark-subtle p-2">
                                <Col><h6>{item.label || 'Extra Material'}</h6></Col>
                                <Col><h6>-</h6></Col>
                                <Col><h6>-</h6></Col>
                                <Col><h6>-</h6></Col>
                                <Col><h6>-</h6></Col>
                                <Col><h6>{item.value || 0}</h6></Col>
                                <Col><h6>{item.qnty || 1}</h6></Col>
                                <Col><h6>{item.price || (Number(item.value || 0) * Number(item.qnty || 1))}</h6></Col>
                                <Col><h6>{item.remark || '-'}</h6></Col>
                              </Row>
                            ))}
                          </>
                        ) : null}

                      </Col>

                    </Row>

                  </Container>

                </Col>
              </Row>


            </Row>


            {/* Bedroom modal */}

          </Row>

        </Col>
      </Row>

    </Container>
  );
}
